/* eslint-disable eqeqeq */

import React from 'react';

interface Props<T> {
    ctx: T;
    items: Array<ContextMenuItem<T>>;
}

interface OpenData {
    x: number;
    y: number;
}

interface State {
    openData: OpenData | null;
}

export interface ContextMenuItem<T> {
    title: string;
    action: (data: T) => void;
}

export class ContextMenu<T> extends React.Component<Props<T>, State> {
    constructor(props: Props<T>) {
        super(props);

        this.state = {
            openData: null
        };

        this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    handleDocumentClick() {
        this.setState({
            openData: null
        });
    }

    componentWillMount() {
        document.addEventListener('click', this.handleDocumentClick);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick);
    }

    openContextMenu(event: React.MouseEvent<HTMLSpanElement, MouseEvent>) {
        if (this.props.items.length == 0) {
            return;
        }
        event.preventDefault();
        this.setState({
            openData: {
                x: event.clientX,
                y: event.clientY
            }
        })
    }

    render() {
        const style: React.CSSProperties = this.state.openData == null
            ? {
                display: 'none'
            }
            : ({
                display: 'block',
                left: this.state.openData.x,
                top: this.state.openData.y
            });
        return (
            <span
                onContextMenu={(ev) => this.openContextMenu(ev)}
            >
                <div
                    key="contextmenu"
                    className="context-menu"
                    id="context-menu"
                    style={style}>
                    <ul>
                        {this.props.items.map((item) => <li
                            key={item.title}
                            onClick={() => item.action(this.props.ctx)}
                        >
                            {item.title}
                        </li>)}
                    </ul>
                </div>
                {this.props.children}
            </ span>
        );
    }
}